<template>
  <div id="app" style="width: 100%">
    <div class="page-header">
      <div class="page-title">公司列表</div>
      <div class="page-header-btn">
        <el-button icon="el-icon-plus" size="mini" style="margin-right: 1rem;" type="primary" @click="add">添加</el-button>
        <el-button icon="el-icon-refresh-right" circle size="mini" :loading="getdeptListLoading"
                   @click="getdeptList()"></el-button>
      </div>
    </div>
    <!--设备列表-->
    <el-table :data="deptList" border style="width: 100%;font-size: 12px;">
      <el-table-column type="index" label="序号" width="50" align="center" />
      <el-table-column prop="companyName" label="公司名称" align="center"/>
      <el-table-column prop="companyLogoPath" label="公司logo" align="center">
        <template slot-scope="{row}">
          <el-image v-if="row.companyLogoPath" style="height: 100px;width: 100px" :src="row.companyLogoPath" alt="加载失败"/>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" >
        <template slot-scope="{row}">
          <span>{{new Date(row.createTime).format("yyyy-MM-dd")}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center" >
        <template slot-scope="{row}">
          <span>{{new Date(row.updateTime).format("yyyy-MM-dd")}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="450" align="center" fixed="right">
        <template slot-scope="{row}">
          <el-button-group>
<!--            <el-button size="mini" icon="el-icon-video-camera-solid" type="primary" @click="add">添加</el-button>-->
            <el-button size="mini" icon="el-icon-video-camera-solid" type="primary" @click="edit(row)">修改</el-button>
            <el-button size="mini" icon="el-icon-delete" type="danger" @click="del(row)">删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-size="count"
      :page-sizes="[10, 20, 30, 50]"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <deptEdit ref="deptEdit" ></deptEdit>
  </div>
</template>

<script>
import axios from '@/api/http.js'
import config from '@/utils/config.js'
import deptEdit from "./dialog/deptEdit";

export default {
  name: "dept",
  components: {
    deptEdit
  },
  data() {
    return {
      deptList: [], //公司列表
      currentPage: 1,
      count: 10,
      total: 0,
      getdeptListLoading: false,
    }
  },
  created() {
    this.getdeptList()
  },
  methods:{
    getdeptList(){
      let that = this;
      this.$axios({ method: 'get', url:`/api/company/list`,params: {
          page: this.currentPage,
          count: this.count
        }}).then(function (res) {
        res.data.data.list.map(s=>{
          return s.companyLogoPath = config.API_ROOT + '/' + s.companyLogoPath
        })
        that.deptList = res.data.data.list;
        that.total = res.data.data.total;
      }).catch(function (error) {
        console.log(error);
      });
    },
    currentChange: function (val) {
      this.currentPage = val;
      this.getdeptList();
    },
    handleSizeChange: function (val) {
      this.count = val;
      this.getdeptList();
    },
    add(){
      this.$refs.deptEdit.openDialog(null, this.getdeptList)
    },
    edit(row) {
      this.$refs.deptEdit.openDialog(row, this.getdeptList)
    },
    del(row) {
      let that = this;
      this.$confirm('确认删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getdeptListLoading = true;
        this.$axios({ method: 'post', url:`/api/company/delete`, params: {companyId: row.companyId} }).then( res => {
          if (res.data.code === 200){
            that.$message.success("删除成功！")
            this.getdeptList()
          }else {
            that.$message.error(res.data.msg)
          }
          this.getdeptListLoading = false;
        })
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dept.vue